import { MapTo } from "@adobe/aem-react-editable-components";
import { AuthoringUtils } from "@adobe/aem-spa-page-model-manager";
import { LoyaltyReferralStats } from "@jti/ui";
import { withAemAuthoring } from "../../app-related/withAemAuthoring";
export const ReferralStatsDashboardEditConfig = {
    emptyLabel: "Referral Stats Dashboard",
    isEmpty: (props) => {
        return (!props.heading ||
            !props.subHeading ||
            !props.friendsReferredDescription ||
            !props.friendsReferredInfoHeading ||
            !props.friendsReferredPoints ||
            !props.friendsReferredSubText ||
            !props.pointsEarnedDescription ||
            !props.pointsEarnedCtaLink ||
            !props.pointsEarnedCtaText ||
            !props.nextTierInfoDescription ||
            !props.nextTierInfoCtaLink ||
            !props.nextTierInfoCtaText ||
            !props.progressBlockBg ||
            !props.progressBlockBgMobile ||
            !props.progressBlockBgTablet ||
            !props.progressBlockHeading ||
            !props.progressBlockDescription ||
            !props.progressBarText ||
            !props.milestonesText ||
            !props.achievementsDoneHeading ||
            !props.achievementsDoneText);
    },
    getProps: (props) => {
        return {
            heading: props.heading,
            subHeading: props.subHeading,
            friendsReferredDescription: props.friendsReferredDescription,
            friendsReferredInfoHeading: props.friendsReferredInfoHeading,
            friendsReferredPoints: props.friendsReferredPoints,
            friendsReferredSubText: props.friendsReferredSubText,
            pointsEarnedDescription: props.pointsEarnedDescription,
            pointsEarnedCtaLink: props.pointsEarnedCtaLink,
            pointsEarnedCtaText: props.pointsEarnedCtaText,
            nextTierInfoDescription: props.nextTierInfoDescription,
            nextTierInfoCtaLink: props.nextTierInfoCtaLink,
            nextTierInfoCtaText: props.nextTierInfoCtaText,
            progressBlockBg: props.progressBlockBg,
            progressBlockBgMobile: props.progressBlockBgMobile,
            progressBlockBgTablet: props.progressBlockBgTablet,
            progressBlockHeading: props.progressBlockHeading,
            progressBlockDescription: props.progressBlockDescription,
            progressBlockHeadingAllDone: props.progressBlockHeadingAllDone,
            progressBlockDescriptionAllDone: props.progressBlockDescriptionAllDone,
            progressBarText: props.progressBarText,
            milestonesText: props.milestonesText,
            isInEditor: AuthoringUtils.isInEditor(),
            achievementsDoneHeading: props.achievementsDoneHeading,
            achievementsDoneText: props.achievementsDoneText,
            isStatsVisible: props.isStatsVisible,
            isAnimatedNumberEnabled: props.isAnimatedNumberEnabled,
        };
    },
};
export default MapTo("loyalty/components/referralStatsDashboard")(withAemAuthoring(LoyaltyReferralStats, ReferralStatsDashboardEditConfig));
